import { useState, useEffect } from "react";
import { getInvoiceAuditHistory } from "./EditInvoiceModal.api";
import { openPdfUrl } from "./UpdateHistoryModal.utils";
import { checkIsStringEmpty } from "features/Common/modules/DataTypes/Strings.utils";

export const useUpdateHistoryModal = (open, record) => {
  const [historyList, setHistoryList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && record) {
      const transactionUuid = record?.uuid || record?.transaction_id;
      if (transactionUuid) {
        setLoading(true);
        getInvoiceAuditHistory(transactionUuid)
          .then((res) => {
            const list = Array.isArray(res?.data?.data)
              ? res.data.data
              : Array.isArray(res?.data)
              ? res.data
              : [];
            setHistoryList(list);
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  }, [open, record]);

  const handleOpenPdf = (url) => {
    if (!checkIsStringEmpty(url)) {
      openPdfUrl(url);
    }
  };

  return {
    historyList,
    loading,
    handleOpenPdf,
  };
};
